<div class="fuel">
  <div class="fuel__price">
    <span class="fuel__price-symbol">$</span>
    <span class="fuel__price-value">{{ fuel.price | number: '1.2' }}</span>
  </div>
  <div class="fuel__type">
    {{ type }}
    <ng-container *ngIf="serviceType"> ({{ serviceType }})</ng-container>
  </div>
</div>
